import { InputField, InputSelectOptions } from 'components'
import LoaderButton from 'components/molecules/loader-button'
import { PAYMENT_STATUS } from 'domains/customer-order/constants/customer-order-constants'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import customerOrderPaymentUpdateStatusSchema from './customer-order-payment-update-status-schema'

import ConfirmationModal from 'components/organisms/confirmation-modal'


const propTypes = {
  onSubmit : PropTypes.func.isRequired,
  payment  : PropTypes.shape({
    id                                 : PropTypes.number,
    status                             : PropTypes.string,
    payment_method_transaction_no      : PropTypes.string,
    payment_method_transaction_remarks : PropTypes.string,
    payment_method                     : PropTypes.shape({
      category: PropTypes.string
    })
  })
}

/**
 * Form to update Customer Order Payment status manually
 * @param {func} onSubmit Handler for submitting the form
 */
const CustomerOrderPaymentUpdateStatusForm = ({
  payment,
  onSubmit
}) => {
  const [ isModalOpen, setIsModalOpen ] = useState(false)
  const toggleOpenModal                 = () => setIsModalOpen((prev) => !prev)

  const showOfflineFields = payment.payment_method.category === 'offline'

  return (
    <Formik
      enableReinitialize={ false }
      initialValues={{
        id                                 : payment.id || '',
        status                             : payment.status || '',
        payment_method_transaction_no      : payment.payment_method_transaction_no || '',
        payment_method_transaction_remarks : payment.payment_method_transaction_remarks || '',
        payment_method                     : {
          category: payment.payment_method.category || ''
        }
      }}
      validationSchema={ customerOrderPaymentUpdateStatusSchema }
      onSubmit={ (_values, formikBag) => {
        formikBag.setSubmitting(false)
        toggleOpenModal()
      } }
    >
      {
        (formikBag) => (
          <Form>
            <InputField
              type='select'
              name='status'
              label='Payment Status'
              required={ true }
            >
              <InputSelectOptions options={ PAYMENT_STATUS } keyPrefix={ 'payment-status' } />
            </InputField>

            {
              showOfflineFields && (
                <>
                  <InputField
                    type='text'
                    name='payment_method_transaction_no'
                    label='Transaction No'
                    required={ true }
                  />

                  <InputField
                    type='text'
                    name='payment_method_transaction_remarks'
                    label='Transaction Remark'
                  />
                </>
              )
            }

            <div className='text-right'>
              <LoaderButton
                color='primary'
                type='submit'
                onSubmit={ formikBag.submitForm }
                disabled={ formikBag.isSubmitting }
                isLoading={ formikBag.isSubmitting }
                text='Update Status'
              />
            </div>


            <ConfirmationModal
              isOpen={ isModalOpen }
              toggle={ toggleOpenModal }
              title={ 'Update Payment Status' }
              handleConfirmation={ () => {
                onSubmit(formikBag.values, formikBag)
                toggleOpenModal()
              } }
            >
              { 'Are you sure want to update the payment status manually?' }
            </ConfirmationModal>
          </Form>
        )
      }
    </Formik>
  )
}

CustomerOrderPaymentUpdateStatusForm.propTypes = propTypes

export default CustomerOrderPaymentUpdateStatusForm